const { CONSTANTS } = require('../../../../config')
const { getRegex } = require('../../../../regex')
const { size } = require('../../../../utils')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string|number} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function ssn ({ value, validationValue }) {
  if (!validationValue) return true

  let val = value
  if (!val) return false

  val = val
    .toString()
    .trim()

  if (val.toUpperCase().substring(10, 11) !== '0123456789ABCDEFHJKLMNPRSTUVWXY'[parseInt(val.substring(0, 6) + '' + val.substring(7, 10)) % 31]) { return false }

  const currentDate = new Date()
  let year = parseInt(val.substring(4, 6), 10)
  const month = parseInt(val.substring(2, 4), 10)
  const day = parseInt(val.substring(0, 2), 10)

  const centurySymbol = val.substring(6, 7)

  switch (centurySymbol) {
    case '+':
      year += 1800
      break
    case 'A':
      year += 2000
      break
    default:
      year += 1900
      break
  }

  const birthDate = new Date(year, (month - 1), day, 10)
  const diffCurrToBirth = Math.abs(currentDate.getTime() - birthDate.getTime())
  const ageAsDate = new Date(diffCurrToBirth)
  const age = Math.abs(ageAsDate.getUTCFullYear() - 1970)

  // Check valid date
  /* istanbul ignore next: really hard to produce error */
  if (Object.prototype.toString.call(birthDate) !== '[object Date]' || isNaN(birthDate.getTime())) return false

  // check if younger then CONSTANTS.AGE.MIN
  if (age < CONSTANTS.FI?.AGE?.MIN) return false

  // check if older than CONSTANTS.AGE.MAX
  if (age > CONSTANTS.FI?.AGE?.MAX) return false

  return size(val.match(getRegex('ssn'))) > 0
}

module.exports = { ssn }
